<div class="container-fluid py-4">
  <div class="row justify-content-md-center py-sm-4 py-md-8">
    <ng-container *ngIf="content$ | async as content">
      <div class="col-md-10">
        <h1 class="pb-sm-4" data-test-id="profile-page-hint">
          <svg-icon src="assets/icons/icon-profile.svg" class="icon-profile"> </svg-icon>
          {{ 'PROFILE_VIEW_TITLE_HINT' | translate }}
        </h1>
        <div class="pb-2">
          <ng-container *ngIf="user">
            <app-user-basic-info
              [content]="content.userBasicInfo"
              [locationUser]="locationUser"
              [user]="user"
              (activeTabChanged)="onActiveTabChanged($event)"
            ></app-user-basic-info>
          </ng-container>
        </div>

        <div>
          <ng-container *ngIf="currentType === ViewProfileTypes.REGULAR">
            <app-regular-user-profile
              [user]="user"
              [fields]="content.fields"
              [displayedName]="content.userBasicInfo.displayedName"
              [isMessageSent]="user.chat"
              [activeUserRoleTab]="activeUserRoleTab"
              (sendMessage)="onSendMessage()"
              (moreInfoOpen)="onMoreInfoOpen($event)"
              (userRelationStatusChanged)="onRelationStatusChanged()"
            ></app-regular-user-profile>
          </ng-container>

          <ng-container *ngIf="currentType === ViewProfileTypes.OWNER">
            <app-owner-profile
              [user]="user"
              [fields]="content.fields"
              [displayedName]="content.userBasicInfo.displayedName"
              (moreInfoOpen)="onMoreInfoOpen($event)"
            ></app-owner-profile>
          </ng-container>
        </div>
      </div>
    </ng-container>
  </div>
</div>
